import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Send, CheckCircle2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NewsletterForm = ({ source = 'website', variant = 'dark', testId = 'newsletter-form' }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const dark = variant === 'dark';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/newsletter/subscribe`, { email, source });
      setDone(true);
      toast.success(data.message);
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Please enter a valid email address');
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div
        data-testid={`${testId}-success`}
        className={`flex items-center gap-3 ${dark ? 'text-[#00D2D3]' : 'text-primary'}`}
      >
        <CheckCircle2 size={22} />
        <span className="font-medium">You're subscribed. Watch your inbox for leadership insights.</span>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} data-testid={testId} className="flex flex-col sm:flex-row gap-3">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your work email"
        data-testid={`${testId}-email`}
        className={`flex-1 px-4 py-3 outline-none transition-all ${
          dark
            ? 'bg-white/10 border border-white/20 text-white placeholder:text-slate-400 focus:border-[#00D2D3]'
            : 'bg-white border border-slate-200 text-primary focus:ring-2 focus:ring-primary focus:border-primary'
        }`}
      />
      <button
        type="submit"
        disabled={loading}
        data-testid={`${testId}-submit`}
        className={`inline-flex items-center justify-center gap-2 px-6 py-3 uppercase tracking-widest text-xs font-semibold transition-all disabled:opacity-50 ${
          dark ? 'bg-[#00D2D3] text-[#1A2238] hover:bg-[#00D2D3]/90' : 'bg-primary text-white hover:bg-primary/90'
        }`}
      >
        {loading ? 'Subscribing...' : 'Subscribe'} <Send size={14} />
      </button>
    </form>
  );
};

export default NewsletterForm;
